import { ServerErrorDefaultProps } from '../SessionOutcome/ServerErrorDefaultProps';

export const SessionCanceledDefaultProps = {
  ...ServerErrorDefaultProps,
  icon: 'cancel',
  title: 'Your session has been canceled',
} as const;
